import React, { useCallback, useEffect, useState } from "react";

import { getAllFarms } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Col, MainPage, Row } from "components";

export const FarmList = () => {
  const [loading, setLoading] = useState(true);
  const [farms, setFarms] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllFarms = useCallback(() => {
    getAllFarms({
      signal,
    })
      .then((res) => {
        setFarms(res.farms);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadAllFarms();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead headline={`${farms.length} farms`} description="View farm details here. You can verify a farm or field on its an page." />
      <Row>
        <Col>
          <AdminTable
            dataSource={farms}
            config={{
              actions: [
                {
                  icon: "tabler/eye",
                  route: "/farm/",
                  tooltip: "View this farm",
                },
              ],
              exclude: [
                "utc",
                "updatedAt",
                "size",
                "pointsPending",
                "pendingFunds",
                "pendingFundedPoints",
                "funds",
                "fundedPoints",
                "fieldsCount",
                "code",
                "landUseA",
                "landUseB",
                "landUseC",
                "claimedHectares",
                "certifications",
                "addressStreet",
                "addressNumber",
                "addressCity",
                "farmEarnings",
                "totalVerificationPoints",
                "fieldModuleVerifications",
                "farmModuleVerifications",
                "owner",
                "reviewerId",
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
